/*
 * Copyright (c) 2023.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ValidatorContent} from './ValidatorContent';

export interface Validator {
  id?: number;
  header: string;
  example?: string;
  featureTypeId: number;
  featureTypeHeader?: string;
  multiple?: boolean;
  content: ValidatorContent;
  deleted?: boolean;
  enabled?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
